"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const withFormControl_1 = __importDefault(require("../form/withFormControl"));
const radio_button_1 = __importDefault(require("../radio-button"));
const styles_1 = require("./styles");
const isRadioItemElement = (element) => (element &&
    typeof element === "object" &&
    "type" in element &&
    element.type === radio_button_1.default) ||
    false;
const RadioGroup = ({ name, className, children, defaultValue, onChange }) => {
    const [selected, setSelected] = (0, react_1.useState)(defaultValue);
    const items = react_1.default.Children.map(children, (child) => {
        if (isRadioItemElement(child)) {
            const { value, className } = child.props;
            const handleOnChange = () => {
                setSelected(value);
                onChange && onChange(value);
            };
            return react_1.default.cloneElement(child, {
                name,
                checked: value === selected,
                onChange: handleOnChange,
                className: (0, classnames_1.default)(styles_1.classes.item, className)
            });
        }
        else {
            return child;
        }
    });
    return (0, jsx_runtime_1.jsx)(styles_1.Container, { className: className, children: items });
};
const controlledRadioGroup = (0, withFormControl_1.default)(RadioGroup);
const RadioGroupFormControl = Object.defineProperty(controlledRadioGroup, "Item", {
    value: radio_button_1.default,
    writable: false
});
exports.default = RadioGroupFormControl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkaW9Hcm91cC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yYWRpby1ncm91cC9SYWRpb0dyb3VwLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDREQUFvQztBQUNwQywrQ0FBd0M7QUFDeEMsOEVBQXNEO0FBQ3RELG1FQUFnRTtBQUNoRSxxQ0FBOEM7QUFVOUMsTUFBTSxrQkFBa0IsR0FBRyxDQUN6QixPQUF3QixFQUM2QyxFQUFFLENBQ3ZFLENBQUMsT0FBTztJQUNOLE9BQU8sT0FBTyxLQUFLLFFBQVE7SUFDM0IsTUFBTSxJQUFJLE9BQU87SUFDakIsT0FBTyxDQUFDLElBQUksS0FBSyxzQkFBVyxDQUFDO0lBQy9CLEtBQUssQ0FBQztBQUVSLE1BQU0sVUFBVSxHQUFHLENBQUMsRUFDbEIsSUFBSSxFQUNKLFNBQVMsRUFDVCxRQUFRLEVBQ1IsWUFBWSxFQUNaLFFBQVEsRUFDRixFQUFFLEVBQUU7SUFDVixNQUFNLENBQUMsUUFBUSxFQUFFLFdBQVcsQ0FBQyxHQUFHLElBQUEsZ0JBQVEsRUFBQyxZQUFZLENBQUMsQ0FBQztJQUV2RCxNQUFNLEtBQUssR0FBRyxlQUFLLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxLQUFLLEVBQUUsRUFBRTtRQUNuRCxJQUFJLGtCQUFrQixDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDOUIsTUFBTSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDO1lBRXpDLE1BQU0sY0FBYyxHQUFHLEdBQUcsRUFBRTtnQkFDMUIsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDO2dCQUNuQixRQUFRLElBQUksUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQzlCLENBQUMsQ0FBQztZQUVGLE9BQU8sZUFBSyxDQUFDLFlBQVksQ0FBQyxLQUFLLEVBQUU7Z0JBQy9CLElBQUk7Z0JBQ0osT0FBTyxFQUFFLEtBQUssS0FBSyxRQUFRO2dCQUMzQixRQUFRLEVBQUUsY0FBYztnQkFDeEIsU0FBUyxFQUFFLElBQUEsb0JBQVUsRUFBQyxnQkFBTyxDQUFDLElBQUksRUFBRSxTQUFTLENBQUM7YUFDL0MsQ0FBQyxDQUFDO1FBQ0wsQ0FBQzthQUFNLENBQUM7WUFDTixPQUFPLEtBQUssQ0FBQztRQUNmLENBQUM7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUVILE9BQU8sdUJBQUMsa0JBQVMsSUFBQyxTQUFTLEVBQUUsU0FBUyxZQUFHLEtBQUssR0FBYSxDQUFDO0FBQzlELENBQUMsQ0FBQztBQUVGLE1BQU0sb0JBQW9CLEdBQUcsSUFBQSx5QkFBZSxFQUFnQixVQUFVLENBQUMsQ0FBQztBQUN4RSxNQUFNLHFCQUFxQixHQUFHLE1BQU0sQ0FBQyxjQUFjLENBQ2pELG9CQUFvQixFQUNwQixNQUFNLEVBQ047SUFDRSxLQUFLLEVBQUUsc0JBQVc7SUFDbEIsUUFBUSxFQUFFLEtBQUs7Q0FDaEIsQ0FDNEQsQ0FBQztBQUVoRSxrQkFBZSxxQkFBcUIsQ0FBQyJ9